import { Grid, Paper, Typography } from '@mui/material';
import Topics from '../../features/Topics/Topics';
import { useEffect } from 'react';
import { io } from 'socket.io-client';
import { useDispatch, useSelector } from 'react-redux';
import { getTopics, loadTopicsRequest } from '../../../redux/topicRedux';
import RepairOrder from '../../features/RepairOrder/RepairOrder';
import {
  getRepairOrders,
  loadRepairOrdersRequest,
} from '../../../redux/repairOrdersRedux';
import { getUser } from '../../../redux/usersRedux';
import { loadBinsByWarehouseRequest } from '../../../redux/binsRedux';
import { loadBeersRequest } from '../../../redux/beersRedux';
import Calendar from '../../features/Calendar/Calendar';
import { SOCKET_URL } from '../../../config';

const socket = io(SOCKET_URL);
const Dashboard = () => {
  const topics = useSelector((state) => getTopics(state));
  const repairOrders = useSelector((state) => getRepairOrders(state));
  const user = useSelector((state) => getUser(state));
  const dispatch = useDispatch();
  useEffect(() => {
    const start = async () => {
      await dispatch(loadTopicsRequest());
      await dispatch(loadRepairOrdersRequest());
      await dispatch(loadBinsByWarehouseRequest(user.users.warehouse));
      await dispatch(loadBeersRequest());
    };
    start();
  }, [dispatch]);

  useEffect(() => {
    // Połączenie WebSocket i nasłuchiwanie zdarzenia "newTopic"
    socket.on('newTopic', (topic) => {
      console.log('Otrzymano nowy temat:', topic);
      // Aktualizacja stanu komponentu
      dispatch(loadTopicsRequest());
    });

    socket.on('closeCurrentTopic', (topicId) => {
      console.log('Temat został zamknięty:', topicId);
      // Aktualizacja stanu komponentu
      dispatch(loadTopicsRequest());
    });

    // Połączenie WebSocket i nasłuchiwanie zdarzenia "newOrder"
    socket.on('newOrder', (order) => {
      console.log('Otrzymano nowe zlecenie:', order);
      // Aktualizacja stanu komponentu
      dispatch(loadRepairOrdersRequest());
    });

    // Połączenie WebSocket i nasłuchiwanie zdarzenia "createSegregation"
    socket.on('segregation', (segregation) => {
      console.log('Otrzymano nowe segregowanie:', segregation);
      dispatch(loadRepairOrdersRequest());
      // Aktualizacja stanu komponentu
    });

    // socket.on('newEvent', (event) => {
    //   console.log('Otrzymano nowe wydarzenie:', event);
    //   dispatch
    //   // Aktualizacja stanu komponentu
    //   // Możesz tutaj dodać odpowiednią akcję do załadowania nowych wydarzeń
    // });

    return () => {
      socket.off('newTopic'); // Wyczyść po odmontowaniu
      socket.off('closeCurrentTopic'); // Wyczyść po odmontowaniu
      socket.off('newOrder'); // Wyczyść po odmontowaniu
      socket.off('segregation'); // Wyczyść po odmontowaniu
      socket.off('newEvent'); // Wyczyść po odmontowaniu
    };
  }, [dispatch]);

  return (
    <Grid container spacing={2} sx={{ height: '90vh', padding: 2, mt: 5 }}>
      {[...Array(4)].map((_, i) => (
        <Grid item xs={6} md={6} key={i} sx={{ height: '50%', mb: 5 }}>
          <Paper
            elevation={3}
            sx={{ height: '100%', padding: 2, overflow: 'auto' }}
          >
            {i === 0 && (
              <Topics
                topics={topics.filter((t) => t.category === 'CURRENT')}
                temat="Brak wiadomości do wyświetlenia"
                naglowek="Tematy bieżące"
                buttonText="Dodaj wiadomość"
                category="CURRENT"
              />
            )}
            {i === 1 && (
              <RepairOrder
                orders={repairOrders}
                temat="Brak otwartych zleceń naprawy"
                naglowek="Zlecenia naprawy"
                buttonText="Dodaj zlecenie naprawy"
              />
            )}
            {i === 2 && (
              <Topics
                topics={topics.filter((t) => t.category === 'INCIDENT')}
                temat="Brak incydentów do wyświetlenia"
                naglowek="Incydenty"
                buttonText="Dodaj incydent"
                category="INCIDENT"
              />
            )}

            {i === 3 && <Calendar />}
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};
export default Dashboard;
